<!-- =========================================================================================
    File Name: i18n.vue
    Description: I18n demo
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent


              <b-col
        lg="2"
        sm="2"
      >
        <statistic-card-horizontal
          icon="ServerIcon"
          color="success"
          statistic="1.2gb"
          statistic-title="Memory Usage"
          style="border:1px dashed #ccc;border-radius:6px;background-color: #fff;"
        />
      
      </b-col>
========================================================================================== -->

<template>
    <div>
      <b-modal
      id="modal-xl"
      ref="file-modal"
      no-close-on-backdrop
      ok-title="Close"
      scrollable
      centered
      button-size="sm"
      size="xl"
      title="File View"
    >
    <iframe :src="selected_file.url" style="border:0px" v-if="selected_file.type == 'pdf'" width="100%" height="600px" type="application/pdf" />
    <div class="text-center">
    <b-img :src="selected_file.url" style="border:0px;max-height:70vh;text-align:center;" v-if="selected_file.type == 'jpg' || selected_file.type == 'png' || selected_file.type == 'jpeg'" type="application/jpeg" /> 
    </div>
    <template #modal-footer="{ ok , closeModal  }">

      
      <b-button size="sm" variant="primary" @click="close()">
        Close
      </b-button>

    </template>
      </b-modal>


      <b-modal
      id="modal-rename"
      ref="modal-rename"
      no-close-on-backdrop
      ok-title="Close"
      centered
      button-size="sm"
      size="sm"
      title="Rename File"
      @shown="highlightName"
    >
        <b-form-group>
          <label for="email">File Name:</label>
          <b-form-input
            id="name"
            type="text"
            ref="filenameInput"
            v-model="filename"
            placeholder="File Name"
          />
        </b-form-group>

      <template #modal-footer="{ ok , closeModal  }">

      
      <b-button size="sm" variant="primary" @click="rename_submit()">
        Submit
      </b-button>

    </template>
      </b-modal>
<b-row>
      <b-col lg="9">
            <b-overlay
              :show="processing"
              spinner-variant="primary"
              spinner-type="grow"
              spinner
              rounded="sm"
            >
            <div class="excel-import">
              <input type="file" ref="fileInput" class="hidden" accept=".jpg, .jpeg, .png, .xls, .xlsx, .doc, .docx, .pdf, .txt" @change="handleClick">
              <div
                @click="$refs.fileInput.click()"
                @drop="handleDrop"
                @dragover="handleDragover"
                @dragenter="handleDragover"
                class="p-1 mb-2 cursor-pointer text-center auto-suggest-suggestions-list ">
                <feather-icon icon="UploadCloudIcon" style="height:4rem !important;width:4rem !important;" svgClasses="stroke-current text-grey" /><br>
                <span> Drop File or </span>
                <span class="font-medium text-primary" @click.stop="$refs.fileInput.click()">Browse</span>
                <!-- <vs-button type="border" @click.stop="$refs.fileInput.click()">Browse</vs-button> -->
              </div>
            </div>
          </b-overlay>
          </b-col>

      
  <b-col
        lg="3"
        sm="3"
      >
        <statistic-card-horizontal
          icon="ServerIcon"
          color="success"
          :statistic="usage"
          statistic-title="Memory Usage"
          style="border:1.5px dashed #ccc;border-radius:6px;background-color: #fff;"
        />
      
      </b-col>
          <b-col lg="12">
            <b-table
      ref="selectableTable"
      :items="items"
      :fields="fields"
      selectable
      :select-mode="'single'"
      responsive
      striped
      class="mb-0 py-2"
      @row-selected="onRowSelected"
    >
    >
      <template #cell(action)="data">
        <b-dropdown
          variant="link"
          no-caret
          :right="$store.state.appConfig.isRTL"
        >

          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>
          <b-dropdown-item @click="download(data.item.id )">
            <font-awesome-icon icon="fa-solid fa-download"  />
            <span class="align-middle ml-50">Download</span>
          </b-dropdown-item>

          <b-dropdown-item @click="rename(data.item.id,data.item.name)">
            <font-awesome-icon icon="fa-solid fa-pen-to-square"  />
            <span class="align-middle ml-50">Rename </span>
          </b-dropdown-item>

          <b-dropdown-item @click="delete_item(data.item.id)">
            <font-awesome-icon icon="fa-solid fa-trash"  />
            <span class="align-middle ml-50">Delete</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
      <template #cell(status_number)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>
      <template #cell(icon)="data">
         <font-awesome-icon class="fa-2x"  :icon="'fa-regular fa-'+data.value"  />
      </template>
     
    </b-table>
          </b-col>
          
    </b-row>
      </div>
      
  </template>
  
  <script>
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'

import { kFormatter } from '@core/utils/filter'

  import UploadDrive from '@core/components/excel/UploadDrive.vue'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import Ripple from 'vue-ripple-directive'
  import { BLink,BImgLazy,BDropdown,
      BDropdownItem,BOverlay,BAlert,BImg,BInputGroup, BInputGroupPrepend, BInputGroupAppend, BFormTextarea,BTable, BListGroup, BListGroupItem, BFormSelect, BBadge, BRow, BCol, BCard, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton } from 'bootstrap-vue'
  import router from '@/router'
  export default {
    components: {
      ToastificationContent,
      UploadDrive,
      BImg,
      StatisticCardVertical,
      StatisticCardHorizontal,
      BImgLazy,
      BLink,
      BInputGroup, BInputGroupPrepend, BInputGroupAppend,  BFormTextarea,BAlert,
      BTable,
      BFormGroup,
      BFormInput,
      BDropdown,
      BDropdownItem,
      BFormSelect,
      BFormCheckbox,
      BForm,
      BButton,
      BCard,
      BBadge,
      BListGroup,
      BOverlay,
      BListGroupItem,
      BRow,
      BCol,
    },
    directives: {
    Ripple,
  },
    props: {
      student : {
        type: String
      },
      userData : {
        type : Object
      }
    },
    created() {
      this.member_id = router.currentRoute.params.id
      this.get_data()
    },
    data () {
      return {
        items:[],
        filename:null,
        tableData: [],
        usage: null,
        selected_file:{
          url:null,
          type:null,
        },
        file_id: null,
        processing: false,
        fields: [
          { key: 'name', label: 'Name' ,sortable:true },
          {key: 'icon', label: 'Type' ,sortable:true},
          {key: 'size', label: 'Size' ,sortable:true},
          { key: 'created_at', label: 'Created At' ,sortable:true },
          { key: 'Action', label: 'Actions'}
        ],
      }
    },
    methods: {
     highlightName() {
  this.$nextTick(() => {
    let input = this.$refs.filenameInput
    // ✅ 若係 bootstrap-vue 組件，取出實際 DOM
    if (input && input.$el) {
      input = input.$el.querySelector('input') || input.$el
    }

    if (input && typeof input.setSelectionRange === 'function') {
      const dotIndex = this.filename.lastIndexOf('.')
      const end = dotIndex > 0 ? dotIndex : this.filename.length
      input.focus()
      input.setSelectionRange(0, end)
    }
  })
},
      get_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/member/`+ this.member_id + `/files/`)
        .then(res => {
          this.items = res.data.records
          this.usage = res.data.usage
        })
    },
      handleDragover (e) {
        e.stopPropagation()
        e.preventDefault()
        e.dataTransfer.dropEffect = 'copy'
      },
      handleDrop (e) {
        e.stopPropagation()
        e.preventDefault()
        const files = e.dataTransfer.files
        if (files.length !== 1) {
          this.$vs.notify({
            title: 'Login Attempt',
            text: 'Only support uploading one file!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
          return
        }
        const rawFile = files[0] // only use files[0]

        this.uploadFile(rawFile)
      },
      close(){
        this.$refs['file-modal'].hide()
      },
      download(id) {
        this.$http.get(process.env.VUE_APP_API_BASE+`/file/`+ id +`/download/`)
            .then(res => {
           //   window.location.href=res.data.url
            })
      },
      onRowSelected(row) {
        this.selected_file = row[0]
        if (this.selected_file.type == 'jpg' ||
          this.selected_file.type == 'jpeg' ||
          this.selected_file.type == 'png' ||
          this.selected_file.type == 'pdf' 
        ) { 
          this.$refs['file-modal'].show()
        }
      },
      rename(id,name) {
        this.filename = name
        this.file_id = id
         this.$refs['modal-rename'].show()
      },
      rename_submit(id) {
         this.$refs['modal-rename'].hide()
         this.$http.post(process.env.VUE_APP_API_BASE+`/file/`+ this.file_id +`/rename/`, {filename: this.filename})
            .then(res => {
              this.get_data()
            })
      },
      delete_item(id) {
      this.$bvModal
        .msgBoxConfirm('確定刪除？', {
          title: '刪除作品',
          size: 'sm',
          okVariant: 'danger',
          okTitle: '確定刪除',
          cancelTitle: '取消',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.$http.post(process.env.VUE_APP_API_BASE+`/file/`+ id +`/delete/`)
            .then(res => {
              this.get_data()
            })
          }
        })
    },
    async uploadFile2(file) {
      const formData = new FormData()
      formData.append('file', file)               // 真實檔案
      formData.append('filename', file.name)  // 其他參數
      formData.append('target_type', 'MEMBER') 
      formData.append('target_uuid', router.currentRoute.params.id) 

      this.processing = true

      this.$http.post(process.env.VUE_APP_API_BASE + '/file/upload/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then(res => {
        this.get_data()
        if (res.data.result === true) {
                  this.processing = false
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                      title: 'Success',
                      icon: 'CheckIcon',
                      variant: 'success',
                      text: res.data.message,
                    },
            })
                } else {
                  this.processing = false
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                      title: 'Error',
                      icon: 'XIcon',
                      variant: 'danger',
                      text: res.data.message,
                    },
                  })
                  this.processing = false
                }
      })
      .catch(err => {
        console.error(err)
        this.processing = false
      })
    },
      readerData (rawFile) {
        this.processing = true
        var file = rawFile
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              console.log( reader.result )
              this.$http.post(process.env.VUE_APP_API_BASE+'/file/upload/',{ 
                base64 : reader.result,
                filename: file.name,
                target_type: 'MEMBER',
                target_uuid: router.currentRoute.params.id
              })
              .then(res => {
                this.get_data()
                if (res.data.result === true) {
                  this.processing = false
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                      title: 'Success',
                      icon: 'CheckIcon',
                      variant: 'success',
                      text: res.data.message,
                    },
            })
                } else {
                  this.processing = false
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                      title: 'Error',
                      icon: 'XIcon',
                      variant: 'danger',
                      text: res.data.message,
                    },
                  })
                  this.processing = false
                }
              })
            }
            reader.onerror = function (error) {
                console.log('Error: ', error)
                this.processing = false
            }  
          
      },
      handleClick (e) {
        const files = e.target.files
        const rawFile = files[0]
        if (!rawFile) return
        this.uploadFile(rawFile)
      },
      async uploadFile (file) {
        this.$refs['fileInput'].value = null // fix can't select the same excel
          this.uploadFile2(file)
        //this.readerData(file)
      }
  
    }
  }
  </script>